// Type filter options organized by category
export const TYPE_FILTER_OPTIONS = [
  // Organised meetings
  { value: 'allOrganised', label: 'All organised meetings', category: 'Organised meetings' },
  { value: 'organisedTentative', label: 'Tentative responses', category: 'Organised meetings' },
  { value: 'organisedPending', label: 'Pending responses', category: 'Organised meetings' },
  { value: 'organisedDeclined', label: 'Declined responses', category: 'Organised meetings' },
  { value: 'remindersSent', label: 'Reminders sent', category: 'Organised meetings' },
  { value: 'hasConflicts', label: 'Has conflicts', category: 'Organised meetings' },
  { value: 'outOfOffice', label: 'Out of office', category: 'Organised meetings' },

  // Attending
  { value: 'allInvited', label: "All meetings I'm invited to", category: 'Attending' },
  { value: 'notAnswered', label: 'Not answered', category: 'Attending' },
  { value: 'tentative', label: 'Tentative', category: 'Attending' },
  { value: 'accepted', label: 'Accepted', category: 'Attending' },
  { value: 'cancelled', label: 'Cancelled', category: 'Attending' },

  // Location
  { value: 'virtual', label: 'Virtual', category: 'Location' },
  { value: 'inPerson', label: 'In person', category: 'Location' },
  { value: 'hybrid', label: 'Hybrid', category: 'Location' },

  // Occurrence
  { value: 'recurring', label: 'Recurring meeting', category: 'Occurrence' },
  { value: 'single', label: 'Single occurrence', category: 'Occurrence' },

  // Meeting type
  { value: 'freeSlot', label: 'Free slot', category: 'Meeting type' },
  { value: 'placeholder', label: 'Placeholder', category: 'Meeting type' },
  { value: 'private', label: 'Private meeting', category: 'Meeting type' },

  // System flags
  { value: 'outOfSync', label: 'Roamer sync error', category: 'System flags' },
] as const;

export type TypeFilterValue = (typeof TYPE_FILTER_OPTIONS)[number]['value'];
export type TypeFilterCategory = (typeof TYPE_FILTER_OPTIONS)[number]['category'];

// Exported list of categories for grouping in UI
export const TYPE_FILTER_CATEGORIES = [
  'Organised meetings',
  'Attending',
  'Location',
  'Occurrence',
  'Meeting type',
  'System flags',
] as const;
